enum VideoTypes {
    TITLE = 'titel',
    CLIP = 'videoKlipp',
    EPISODE = 'videoEpisod',
    SINGLE = 'singel',
}

export default VideoTypes;
